<div class="container">
  @if (estado == 0) {
    <app-generic-notification
      [titleNotification]="'Ejecución de Mantenimiento para'"
      [note]="'Si ya finalizo el mentenimiento cierre la orden de trabajo'"
      [closeButton]="true"
      [commentButton]="true"
      (closeOrder)="close()"
      (addComment)="addComment($event)">
    </app-generic-notification>
  }

  @if (estado == 1) {
    <mat-card appearance="outlined" style="background-color: #ffffff7a;">
      <mat-card-content class="mat-body-1">
        <app-close-order
          (bodyOrder)="bodyOrden"
          [orderId]="orderId"
        ></app-close-order>
      </mat-card-content>
    </mat-card>
  }
</div>